import React from 'react';

import { useAddressFormContext } from '../../context';
import { CityField } from '../../fields/city';
import { CompanyField } from '../../fields/company';
import { CountryField } from '../../fields/country';
import { EmailField } from '../../fields/email';
import { Line1Field } from '../../fields/line1';
import { Line2Field } from '../../fields/line2';
import { Line3Field } from '../../fields/line3';
import { NameField } from '../../fields/name';
import { PhoneField } from '../../fields/phone';
import { PostalCodeField } from '../../fields/postal-code';
import { StateField } from '../../fields/state';
import style from '../../style.module.less';

export const CAFields = () => {
  const { line3, type } = useAddressFormContext();

  if (type && type === 'v2') {
    return (
      <div className={style.country}>
        <CountryField />
        <NameField optional />
        <CompanyField />
        <Line1Field />
        <Line2Field />
        {line3 && <Line3Field />}
        <div className={style['city-state-zip']}>
          <CityField />
          <StateField />
          <PostalCodeField />
        </div>
        <EmailField optional />
        <PhoneField />
      </div>
    );
  }

  return (
    <>
      <NameField />
      <CompanyField />{' '}
      {/* JDB 1/27/2022 This field for CA is displayed as non-optional while purposefully not considered required by validation in address-fields/address-schema.js */}
      <CountryField />
      <Line1Field />
      <Line2Field />
      {line3 && <Line3Field />}
      <div className={style['city-state-zip']}>
        <CityField />
        <StateField />
        <PostalCodeField />
      </div>
      <PhoneField optional />
      <EmailField optional />
    </>
  );
};
